import type { Dictionary } from '@/types/global'
interface TableResult {
  tableData: Dictionary[],
  count?: string,
}

export function useTable(getTableData: (params?: any) => Promise<TableResult>) {
  const pageNum = ref(1)
  const pageSize = ref(20)
  const count = ref(0) // 总条数
  const tableData = ref<any[]>([])
  const tableDataFileter = ref<any[]>([]) // 用于筛选
  const searchForm = ref({}) // 搜索的参数
  const isLoading = ref(false)
  const isDeviceReset = ref('') // 子设备-产品搜索
  const isOtaProductKey = ref('') // OTA-产品搜索
  const isMessageReset = ref('') // 消息订阅-产品清除
  const isConfigAgreementProductKey = ref('') // 远程配置/产品协议-下发记录-产品下拉

  const DropdownItem = ref({ value: '', label: '', columns: '', key: '' }) // 列表项筛选

  function handleSizeChange(newPageSize: number) {
    pageSize.value = newPageSize
    query()
  }
  function handleCurrentChange(newPageNum: number) {
    pageNum.value = newPageNum
    query()
  }
  // 列表表头下拉筛选
  // todo:这里考虑一下多表头关联选择之后再筛选的功能如何做
  function handleDropdown(newDropdownItem: any) {
    DropdownItem.value = newDropdownItem
    if (DropdownItem.value.value !== 'all' && DropdownItem.value.value !== '')
      tableData.value = tableDataFileter.value.filter(i => i[DropdownItem.value.key] === DropdownItem.value.value)
    else
      tableData.value = tableDataFileter.value
  }
  // 列表表头-时间排序
  function handleSort(newSort: any, val: any) {
    if (val === 'SortUp')
      tableData.value = tableDataFileter.value.sort((a: any, b: any) => new Date(a[newSort]).getTime() - new Date(b[newSort]).getTime())
    else if (val === 'SortDown')
      tableData.value = tableDataFileter.value.sort((a: any, b: any) => new Date(b[newSort]).getTime() - new Date(a[newSort]).getTime())
  }
  async function handleSearch(form?: Dictionary, val?: any) {
    if (form) {
      searchForm.value = form
      pageNum.value = 1 // 重置到第一页
    }
    isDeviceReset.value = val
    isOtaProductKey.value = val
    isConfigAgreementProductKey.value = val
    isMessageReset.value = val
    await query()
  }

  async function query() {
    isLoading.value = true
    // query()前重置 DropdownItem.value
    DropdownItem.value = { value: '', label: '', columns: '', key: '' }
    try {
      const result = await getTableData({
        ...searchForm.value,
        pageNum: pageNum.value,
        pageSize: pageSize.value,
      })
      count.value = Number(result.count)
      tableData.value = result.tableData
      tableDataFileter.value = result.tableData
    } catch (error) {
      console.log('error', error)
      count.value = 0
      tableData.value = []
    } finally {
      isLoading.value = false
    }
  }

  const attrs = computed(() => { // 属性值通过v-bind的形式透传
    return {
      tableData: tableData.value,
      count: count.value,
      pageNum: pageNum.value,
      pageSize: pageSize.value,
    }
  })

  return {
    attrs,
    events: { sizeChange: handleSizeChange, currentChange: handleCurrentChange, pageDropdown: handleDropdown, pageSort: handleSort },
    searchForm,
    DropdownItem,
    handleSearch,
    isLoading,
    isDeviceReset,
    isOtaProductKey,
    isConfigAgreementProductKey,
    isMessageReset,
  }
}

